import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
//import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

import { LaddaModule } from 'angular2-ladda';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { OrderModule } from 'ngx-order-pipe';
import { ExportAsModule } from 'ngx-export-as';

import { FullComponent } from './layouts/full/full.component';
/*import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';*/

import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { setTheme } from 'ngx-bootstrap/utils';
setTheme('bs4');

import { Hivimarroutes } from './hivimar-routing';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HivimarComponent } from '../hivimar/hivimar.component';

import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
/*import {CalendarModule} from 'primeng/calendar';*/
import {SliderModule} from 'primeng/slider';
import {MultiSelectModule} from 'primeng/multiselect';
import {ContextMenuModule} from 'primeng/contextmenu';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {ProgressBarModule} from 'primeng/progressbar';
import {InputTextModule} from 'primeng/inputtext';
import {PanelModule} from 'primeng/panel';
import {TabViewModule} from 'primeng/tabview';
import {FieldsetModule} from 'primeng/fieldset';
import {ListboxModule} from 'primeng/listbox';

import { SignaturePadModule } from '@ng-plus/signature-pad';
import { ChartsModule } from 'ng2-charts';

import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { AgmDrawingModule } from '@agm/drawing';
import { LightboxModule } from 'ngx-lightbox';
import { BaseCrudComponent } from './base-crud/base-crud.component';

import { UsersComponent } from './admins/users/users.component';
import { HomeComponent } from './home/home.component';
import { ColaboratorsComponent } from './colaborators/colaborators.component';
import { AdminsComponent } from './admins/admins.component';

import { CalendarModule, CalendarDateFormatter } from 'angular-calendar';
import { MonthscheduleComponent } from './month-schedule/month-schedule.component';
import { WeatherheaderComponent } from './weather-header/weather-header.component';
import { CommentComponent } from './recent-comments/comment.component';

import { SettingsComponent } from './settings/settings.component';

import { RoleComponent } from './admins/role/role.component';
import { RepohomeComponent } from './reports/repohome/repohome.component';
import { MasterrouteComponent } from './reports/masterroute/masterroute.component';
import { PendingordersComponent } from './reports/pendingorders/pendingorders.component';
import { RouteaccomplishComponent } from './reports/routeaccomplish/routeaccomplish.component';
import { SalesbycategoryComponent } from './reports/salesbycategory/salesbycategory.component';
import { SalesbyclientComponent } from './reports/salesbyclient/salesbyclient.component';
import { SalesbyclientcategoryComponent } from './reports/salesbyclientcategory/salesbyclientcategory.component';
import { ControlpanelComponent } from './reports/controlpanel/controlpanel.component';
import { LogihomeComponent } from './logi/logihome/logihome.component';
import { LogiadminComponent } from './logi/logiadmin/logiadmin.component';
import { RoutesComponent } from './logi/logiadmin/routes/routes.component';
import { DriversComponent } from './logi/logiadmin/drivers/drivers.component';
import { DestinationsComponent } from './logi/logiadmin/destinations/destinations.component';
import { VehiclesComponent } from './logi/logiadmin/vehicles/vehicles.component';
import { MonitoringComponent } from './logi/logiadmin/monitoring/monitoring.component';
import { LogidriverComponent } from './logi/logidriver/logidriver.component';
import { DriverprofileComponent } from './logi/logidriver/driverprofile/driverprofile.component';
import { MyroutesComponent } from './logi/logidriver/myroutes/myroutes.component';
import { RouteaccomplishsupervComponent } from './reports/routeaccomplishsuperv/routeaccomplishsuperv.component';
import { MyroutedetailComponent } from './logi/logidriver/myroutes/myroutedetail/myroutedetail.component';
import { PortfolioanalysisComponent } from './reports/portfolioanalysis/portfolioanalysis.component';
import { ControlpanelsupervComponent } from './reports/controlpanelsuperv/controlpanelsuperv.component';
import { SalesbysellercategorysupervComponent } from './reports/salesbysellercategorysuperv/salesbysellercategorysuperv.component';
import { PortfolioanalysissupervComponent } from './reports/portfolioanalysissuperv/portfolioanalysissuperv.component';
import { LogiclientComponent } from './logi/logiclient/logiclient.component';
import { PortfolioanalysischiefComponent } from './reports/portfolioanalysischief/portfolioanalysischief.component';
import { ControlpanelchiefComponent } from './reports/controlpanelchief/controlpanelchief.component';
import { SalesbysupervcategorychiefComponent } from './reports/salesbysupervcategorychief/salesbysupervcategorychief.component';
import { LiverouteComponent } from './logi/logidriver/myroutes/liveroute/liveroute.component';
import { CommonComponent } from './layouts/common/common.component';
import { RoutesreportComponent } from './logi/logiadmin/routesreport/routesreport.component';
import { TrackingreportComponent } from './logi/logireports/tracking/trackingreport/trackingreport.component';
import { KpidriverComponent } from './logi/logireports/kpidriver/kpidriver.component';
import { KpicustservComponent } from './logi/logireports/kpicustserv/kpicustserv.component';
import { KpideliverytimeComponent } from './logi/logireports/kpideliverytime/kpideliverytime.component';
import { KpistoptimeComponent } from './logi/logireports/kpistoptime/kpistoptime.component';
import { KpihomeComponent } from './logi/logireports/kpihome/kpihome.component';
import { CustomersComponent } from './reports/customers/customers.component';
import { CustomersCollectorsComponent } from './reports/customerscollectors/customerscollectors.component';
import { InfoFilesComponent } from './sales/info-files/info-files.component';
import { SalesHomeComponent } from './sales/sales-home/sales-home.component';
import { AgentsComponent } from './sales/agents/agents.component';
import { AgentBackupComponent } from './sales/agent-backup/agent-backup.component';
import { SysparamsComponent } from './admins/sysparams/sysparams.component';
import { AgentManagementReportComponent } from './sales/agent-management-report/agent-management-report.component';
import { OrderFollowupReportComponent } from './sales/order-followup-report/order-followup-report.component';
import { CurrentVersionReportComponent } from './sales/current-version-report/current-version-report.component';
import { SyncAuditReportComponent } from './sales/sync-audit-report/sync-audit-report.component';
import { OrderApproversComponent } from './sales/order-approvers/order-approvers.component';
import { GradesComponent } from './sales/grades/grades.component';
import { SubjectsComponent } from './sales/subjects/subjects.component';
import { MaterialgroupComponent } from './sales/discounts/materialgroup/materialgroup.component';
import { BrandComponent } from './sales/discounts/brand/brand.component';
import { GroupbrandComponent } from './sales/discounts/groupbrand/groupbrand.component';
import { ClientsComponent } from './admins/clients/clients.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20
};

/*registerLocaleData(localeEs);*/

@NgModule({
  declarations: [
    FullComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    HivimarComponent,
    BaseCrudComponent,
    SettingsComponent,
    UsersComponent,
    HomeComponent,
    ColaboratorsComponent,
    AdminsComponent,
    MonthscheduleComponent,
    WeatherheaderComponent,
    CommentComponent,
    RoleComponent,
    RepohomeComponent,
    MasterrouteComponent,
    PendingordersComponent,
    RouteaccomplishComponent,
    SalesbycategoryComponent,
    SalesbyclientComponent,
    SalesbyclientcategoryComponent,
    ControlpanelComponent,
    LogihomeComponent,
    LogiadminComponent,
    RoutesComponent,
    DriversComponent,
    DestinationsComponent,
    VehiclesComponent,
    MonitoringComponent,
    LogidriverComponent,
    DriverprofileComponent,
    MyroutesComponent,
    RouteaccomplishsupervComponent,
    MyroutedetailComponent,
    PortfolioanalysisComponent,
    ControlpanelsupervComponent,
    SalesbysellercategorysupervComponent,
    PortfolioanalysissupervComponent,
    LogiclientComponent,
    PortfolioanalysischiefComponent,
    ControlpanelchiefComponent,
    SalesbysupervcategorychiefComponent,
    LiverouteComponent,
    CommonComponent,
    RoutesreportComponent,
    TrackingreportComponent,
    KpidriverComponent,
    KpicustservComponent,
    KpideliverytimeComponent,
    KpistoptimeComponent,
    KpihomeComponent,
    CustomersComponent,
    CustomersCollectorsComponent,
    InfoFilesComponent,
    SalesHomeComponent,
    AgentsComponent,
    AgentBackupComponent,
    SysparamsComponent,
    AgentManagementReportComponent,
    OrderFollowupReportComponent,
    CurrentVersionReportComponent,
    SyncAuditReportComponent,
    OrderApproversComponent,
    GradesComponent,
    SubjectsComponent,
    MaterialgroupComponent,
    BrandComponent,
    GroupbrandComponent,
    ClientsComponent
  ],
  imports: [
    CommonModule,
    ChartsModule,
    BrowserModule,
    BrowserAnimationsModule,
    TableModule,
    MultiSelectModule,
    TabViewModule,
    FieldsetModule,
    ListboxModule,
    ToastModule,
    PanelModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    HttpClientModule,
    NgbModule,
    RouterModule.forRoot(Hivimarroutes),
    PerfectScrollbarModule,
    //NgMultiSelectDropDownModule.forRoot(),
    DropdownModule,
    AgmCoreModule,
    AgmJsMarkerClustererModule,
    AgmDrawingModule,
    BsDatepickerModule.forRoot(),
    LaddaModule,
    SignaturePadModule,
    CalendarModule.forRoot(),
    TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
    OrderModule,
    ExportAsModule,
    LightboxModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    DatePipe
  ]/*,
  bootstrap: [AppComponent]*/
})
export class HivimarModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    //return new TranslateHttpLoader(http);
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}